import versionData from 'assets/JSON/appVersion.json';

export const environment = {
  name:"PREPROD",
  production: true,
  baseUrl:window.location.origin,
  odRedirection:"/1/#",
  debugMode: false,
  appVersion: versionData.appVersion
};



export let ENV_CONSTANTS = {

  googleAppId: "1048290467303-nhgvdqi0djev52d1ik88f3ogvljo9sib.apps.googleusercontent.com",
  // fbAppId: "148600422142033",
  appleAppId: "com.jio.cloud.jiodriveService",
  appleRedirectUrl: window.location.origin,
  environmentsNames: {
    "https://pp-www.tejdrive.com": "preprod"
  },

  envHeaders: {
    preprod:{ //preprod environment
      "X-Api-Key": "0b374bf6-26b8-4b5d-ba17-5167ce583853",
      "X-Client-Details": "clientType:WEB; appVersion:49.0.7",
      "X-App-Secret": "ODc0MDE2M2EtNGY0MC00YmU2LTgwZDUtYjNlZjIxZGRkZjlj",
      "Content-Type": "application/json; charset=UTF-8",
      "Accept": "application/json; charset=UTF-8",
      "X-Device-Type": "W",
    }
  },
  privateUrls:{
    preprod:{ //sit environment
      jtrUrl:"https://jtr-pp-www.tejdrive.com"
    }
  },
  multiDCUrls:{
    preprod:{
      JAWS: {
        "baseURL": "https://jaws-pp-apis.tejdrive.com",
        "baseWebURL": "https://pp-www.tejdrive.com",
        "uploadURL": "https://jaws-pp-upload.tejdrive.com",
        "autoUploadURL": "https://jaws-pp-autoupload.tejdrive.com",
        "contactsURL": "https://jaws-pp-contacts.tejdrive.com",
        "nmsURL": "https://jaws-pp-apis.tejdrive.com",
        "boardURL": "https://jaws-pp-boards.tejdrive.com",
        "shareURL": "https://jaws-pp-apis.tejdrive.com",
        "notificationsURL": "https://jaws-pp-apis.tejdrive.com",
        "securityURL": "https://pp-apis.tejdrive.com",
        "downloadURL": "https://jaws-pp-dl.tejdrive.com",
        "inviteURL": "https://jaws-pp-boards.tejdrive.com",
        "trashURL": "https://pp-www.tejdrive.com/#/trash",
        "upgradeStorageURL": "https://static.jiocloud.com/upgrade/upgrade.html",
        "subscriptionURL": "https://www.jio.com",
        "privacyPolicyURL": "https://static.jiocloud.com/privacypolicy.html",
        "faqURL": "https://pp-www.tejdrive.com/help/home/?m=",
        "termofServiceURL": "https://static.jiocloud.com/tos.html",
        "thirdPartyPolicyURL": "https://static.jiocloud.com/licenses.html",
        "infoURL": "https://pp-www.tejdrive.com/features?mobile=true",
        "boardUploadURL": "https://jaws-pp-boardsupload.tejdrive.com",
        "promotionFaqURL": "https://static.jiocloud.com/promotions.html",
        "pbsURL": "https://pp-apis.tejdrive.com",
        "msgCallLogURL": "https://jaws-pp-msg.tejdrive.com",
        "baseDCURL": "https://jaws-pp-apis.tejdrive.com",
        "globalDCURL": "https://pp-apis.tejdrive.com",
        "prmURL": "https://jaws-pp-msg.tejdrive.com",
        "admncURL": "https://jaws-pp-apis.tejdrive.com",
        "tmfldURL": "https://jaws-pp-apis.tejdrive.com",
        "fgpURL": "https://jaws-pp-msg.tejdrive.com",
        "sioURL": "https://jaws-pp-apis.tejdrive.com",
        "jcaURL": "https://jaws-pp-apis.tejdrive.com",
        "aseURL": "https://jaws-pp-apis.tejdrive.com",
        "otherURL": "https://jaws-pp-apis.tejdrive.com",
        "staticCdnUrl": "https://static.jiocloud.com",
        "dcGroupCode": "JAWS"
      },
      JMNG:{
        "baseURL": "https://jaws-pp-apis.tejdrive.com",
        "baseWebURL": "https://pp-www.tejdrive.com",
        "uploadURL": "https://jmng1-pp-upload.tejdrive.com",
        "autoUploadURL": "https://jmng1-pp-autoupload.tejdrive.com",
        "contactsURL": "https://jmng1-pp-contacts.tejdrive.com",
        "nmsURL": "https://jmng1-pp-apis.tejdrive.com",
        "boardURL": "https://pp-boards.tejdrive.com",
        "shareURL": "https://jmng1-pp-apis.tejdrive.com",
        "notificationsURL": "https://pp-apis.tejdrive.com",
        "securityURL": "https://pp-apis.tejdrive.com",
        "downloadURL": "https://jmng1-pp-dl.tejdrive.com",
        "inviteURL": "https://pp-boards.tejdrive.com",
        "trashURL": "https://pp-www.tejdrive.com/#/trash",
        "upgradeStorageURL": "https://static.jiocloud.com/upgrade/upgrade.html",
        "subscriptionURL": "https://www.jio.com",
        "privacyPolicyURL": "https://static.jiocloud.com/privacypolicy.html",
        "faqURL": "https://pp-www.tejdrive.com/help/home/?m=",
        "termofServiceURL": "https://static.jiocloud.com/tos.html",
        "thirdPartyPolicyURL": "https://static.jiocloud.com/licenses.html",
        "infoURL": "https://pp-www.tejdrive.com/features?mobile=true",
        "boardUploadURL": "https://jmng1-pp-boardsupload.tejdrive.com",
        "promotionFaqURL": "https://static.jiocloud.com/promotions.html",
        "pbsURL": "https://pp-apis.tejdrive.com",
        "msgCallLogURL": "https://jmng1-pp-msg.tejdrive.com",
        "baseDCURL": "https://jmng1-pp-apis.tejdrive.com",
        "globalDCURL": "https://pp-apis.tejdrive.com",
        "prmURL": "https://jmng1-pp-msg.tejdrive.com",
        "admncURL": "https://jaws-pp-apis.tejdrive.com",
        "tmfldURL": "https://jmng1-pp-apis.tejdrive.com",
        "fgpURL": "https://jmng1-pp-msg.tejdrive.com",
        "sioURL": "https://jmng1-pp-apis.tejdrive.com",
        "jcaURL": "https://jmng1-pp-apis.tejdrive.com",
        "aseURL": "https://jmng1-pp-apis.tejdrive.com",
        "otherURL": "https://jaws-pp-apis.tejdrive.com",
        "staticCdnUrl": "https://static.jiocloud.com",
        "dcGroupCode": "JMNG"
      }
    }
  },

  constants:{
    maxTagLimit : 10,
    Interval_2FA : 20,
    mediaStreamTokenExpiry: 4 * 60 * 1000,
    Interval_PPF : 5,
    passPhraseattempts:4,
    intervalTime:10000, // in milliseconds
    maxFamilyInviteLimit:5,
    enableStoragePurchase:true,
    showFamilyShare:true,
    enablePricingTab:false,
    enableJTR:true,
    shareSessionExpiry: 300000,
    maxFilesDownloadLimit:1000,
    maxBulkDownloadLimit:20, // in GB
    maxRetryLimitForBulkDownload:3,
    localStorageKeysExpiryTime:30,
    maxFileCountForDragAndDrop:1000,
    maxFileSizeForDragAndDrop:5, // in GB
    promoId: 'spinthewheel',
    enablePrePromotion:false,
    enableTakeout:true,
    chromeBookPublicShare : 'extshare=',
    profilStorageSummeryPlanStartingFrom : '29',
    enableTeamFolders : true,
    enableManageVersions: true,
    enableOfficeForWebPreview: true,
    memory_Image_Timer_In_Milliseconds: 30, // in milliseconds
    enableAppleLogin : true,
    enableDowntimeBanner: false,
    downTimeBanner: 60 ,// in minutes
    landingDownloadappLink: "https://jiocloud.page.link/downloadApp",
    enableSocialLogin : true
  },
  thirdpartyUrls:{
    jioId_signIn:"https://replica.id.jio.com/?appIdentifier=JPL_JioCloud&flowName=web_site_signin",
    jioId_signOut:"https://replica.id.jio.com/?appIdentifier=JPL_JioCloud&flowName=web_site_signout"
  },
};